import { PortalMaterialOrderStatusEnum } from '@routellers/types/dist/partners-portal/enum/portal-material-order-status.enum';
import type { TFunction } from 'i18next';

import { enumLabel, enumOptions } from '../i18n/enum-options';

export const orderStatusColors: Record<
    PortalMaterialOrderStatusEnum,
    'orange' | 'blue' | 'teal' | 'green' | 'red'
> = {
    [PortalMaterialOrderStatusEnum.NEW]: 'orange',
    [PortalMaterialOrderStatusEnum.PROCESSING]: 'blue',
    [PortalMaterialOrderStatusEnum.SHIPPED]: 'teal',
    [PortalMaterialOrderStatusEnum.DONE]: 'green',
    [PortalMaterialOrderStatusEnum.CANCELED]: 'red',
};

export const orderStatusLabel = (t: TFunction, value: PortalMaterialOrderStatusEnum) =>
    enumLabel(t, 'enums.materialOrderStatus', value);

export const orderStatusOptions = (t: TFunction) =>
    enumOptions(Object.values(PortalMaterialOrderStatusEnum), t, 'enums.materialOrderStatus');

export const formatDate = (date?: Date | string): string =>
    date ? new Date(date).toLocaleDateString() : '—';

export const formatDateTime = (date?: Date | string): string =>
    date ? new Date(date).toLocaleString() : '—';

export const formatMoneyMap = (map?: Record<string, number>): string => {
    const entries = Object.entries(map || {}).filter(([, value]) => value);

    if (!entries.length) return '0';

    return entries
        .map(([currency, minor]) => {
            try {
                return new Intl.NumberFormat(undefined, {
                    style: 'currency',
                    currency: currency.toUpperCase(),
                }).format(minor / 100);
            } catch {
                return `${(minor / 100).toFixed(2)} ${currency.toUpperCase()}`;
            }
        })
        .join(', ');
};

export const formatMoneyCents = (cents: number, currency = 'eur'): string => {
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency.toUpperCase(),
        }).format(cents / 100);
    } catch {
        return `${(cents / 100).toFixed(2)} ${currency.toUpperCase()}`;
    }
};
